var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobRevinPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m251.79 242.27h-223.58l2.88-42.6-7.9-21.44 49.25-15.74h135.12l49.25 15.74-7.9 21.44z",
    fill: "#4f4f4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m279.5 280.26h-279l1-19 4.99-20.85 133.51-49.15 133.51 49.15 4.99 20.85z",
    fill: "#4f4f4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m257.64 314.12h-235.28l-17.68-79.61 135.32-49.47 135.32 49.47z",
    fill: "#2d2d2d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m221 78.14-50.53-51.11h-60.19l-50.53 51.11-2.89 61.89 13.09 68.18h36.74 67.37 36.74l13.09-68.18z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m154.42 51.5h-28.84l-50.83 31.42-2.34 60.03 14.62 46.19 30.75 23.88h44.44l30.6-23.88 14.77-46.19-2.34-60.03z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m78.7 164.07 22.53 3.65 18.44 18.86 13.99 23.26-33.3-2.65-13.76-17.88z",
    fill: "#6d6d6d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m208.04 142.54-68.04 10.07-68.04-10.07-4.45-28.19 72.49-10.07 72.49 10.07z",
    fill: "#d61846"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m150.83 105.45-10.83 61.78-10.83-61.78-41.28-31.96 52.11-4.18 52.11 4.18z",
    fill: "#6d6d6d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m200.92 164.07-22.53 3.65-18.44 18.86-13.99 23.26 33.3-2.65 13.79-17.88z",
    fill: "#6d6d6d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m223.52 73.19-52.34-52.94h-62.36l-52.34 52.94-3 64.12 13.57 70.62h12.62l-14.24-56.84 14.85-48.57 33.8-28.76h51.84l33.8 28.76 14.85 48.57-14.24 56.84h12.62l13.57-70.62z",
    fill: "#2d2d2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d3d3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m236.82 255.62-97.12 20-96.52-20-6.17-42.6 10.48-26.08 16.31-2.26 35.16 18.1 41.04 7.36 41.04-7.36 35.16-18.1 16.31 2.26 10.48 26.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.55 73.76h-47.7l-6.35-54.68h60.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobRevinPilot);
export default __webpack_public_path__ + "static/media/mob-revin-pilot.731d2212bd6818c971c01719862a857d.svg";
export { ForwardRef as ReactComponent };